import React, { ReactNode } from 'react';

type IAppThemeContext = {
	theme: string;
	changeTheme: (theme: string) => void;
	resetTheme: () => void;
};

const AppThemeContext = React.createContext<IAppThemeContext>({
	theme: 'light',
	changeTheme: () => {
		null;
	},
	resetTheme: () => {
		null;
	},
});

export const useAppTheme = () => {
	return React.useContext(AppThemeContext);
};

type AppThemeProviderProps = {
	children?: ReactNode;
};

const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children }) => {
	const [theme, setTheme] = React.useState(localStorage.getItem('global.theme') ?? 'light');
	//i18next.changeTheme('fr');
	const changeTheme = (theme: string) => {
		setTheme(theme);
		localStorage.setItem('global.theme', theme);
	};

	const resetTheme = () => {
		setTheme('light');
		localStorage.setItem('global.theme', 'light');
	};

	const contextValue = React.useMemo(() => {
		return {
			theme,
			changeTheme,
			resetTheme,
		};
	}, [theme]);

	return <AppThemeContext.Provider value={contextValue}>{children}</AppThemeContext.Provider>;
};

export default AppThemeProvider;
